import { TFunction } from 'i18next';

interface TitleProps {
  showPhoneNumber: boolean;
  showVerificationStep: boolean;
  t: TFunction;
}

export const getAuthBodyTitle = (props: TitleProps): string | undefined => {
  const { showPhoneNumber, showVerificationStep, t } = props;

  if (showPhoneNumber) {
    return showVerificationStep
      ? t('auth.confirmation-code')
      : t('account.edit-profile.phone');
  } else {
    return undefined;
  }
};

interface DescriptionProps {
  showPhoneNumber: boolean;
  showVerificationStep: boolean;
  phoneNumber?: string;
  t: TFunction;
}

export const getAuthBodyDescription = (
  props: DescriptionProps
): string | undefined => {
  const { showPhoneNumber, showVerificationStep, phoneNumber, t } = props;
  if (showPhoneNumber) {
    return showVerificationStep && phoneNumber
      ? t('auth.six-digit-code-sent-to-phone').replace(
        'PHONE_NUMBER',
        phoneNumber.slice(-4)
      )
      : t('auth.enter-phone-number');
  } else {
    return undefined;
  }
};
